import React, { useState, useEffect } from "react";
import ArrowRight from "images/icons/arrow-right.inline.svg";

const TextAccordion = ({ data, className, isOpenTag }) => {
  const [isOpened, setOpened] = useState(false);
  const handleAccordion = () => {
    setOpened(!isOpened);
  };

  const dataTag = data.title
    .replace(/[-\s]+/g, "-")
    .replace(/-+$/, "")
    .replace(/[,"'+]/g, "")
    .toLowerCase();

  useEffect(() => {
    if (dataTag === isOpenTag) setOpened(!isOpened);
  }, [isOpenTag]);

  return (
    <div className={className}>
      <div
        className={
          "flex justify-between items-center p-4 bg-black-lighter planet:bg-gray-standard rounded-xs text-white"
        }
        onClick={handleAccordion}
      >
        <p className="h7 !text-white !text-base uppercase">{data.title}</p>
        <ArrowRight
          className={`visible w-3 h-3 stroke-white ${
            isOpened ? "-rotate-90" : "rotate-90"
          }`}
        />
      </div>

      <div
        className={`mt-8 overflow-y-auto gvi-scrollbar-thin transition-all duration-200 tab-content ${
          isOpened ? "max-h-80 mb-10" : "h-0"
        }`}
        id={dataTag}
      >
        <div
          className="pb-5 sm:pb-0 pr-10 text-black-lighter planet:text-gray-generic tab-content_html"
          dangerouslySetInnerHTML={{ __html: data.desc }}
        />
      </div>
    </div>
  );
};

export default TextAccordion;
